export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";